module.exports = __webpack_public_path__ + "static/media/load.901cb84e.gif";